<ng-template #docuemntTemplateList>
	<div fxLayout="row wrap m-0" fxLayoutAlign="space-between" class="border-bottom">
		<h3 class="arc-h3 margin-20" >Document Templates</h3>
		<div class="col-sm-2 text-right">
			<app-close-mat-dialog (closeDialog)="dialogRef.close()"></app-close-mat-dialog>
		</div>
	</div>
	<mat-dialog-content>
		<div class="document">
			<div class="inner-text">
				Select the <span class="inner-text text-color" matTooltip="{{ standardText }}" [appAnnounceTooltip]="standardText">standard</span> or
				<span class="inner-text text-color" matTooltip="{{ localText }}" [appAnnounceTooltip]="localText">local</span>
				template that you would like to generate. Local templates will be generated as a Word document. Standard
				templates can be auto-generated as a PDF or generated as a Word document.
			</div>
			<div class="margin-top-20">
				<div fxLayout="row wrap" fxLayoutAlign="space-between stretch" class="margin-bottom-10">
					<div fxFlex="29.3" fxFlex.md="29.3" fxFlex.sm="100" fxFlex.xs="100" class="margin-bottom-10">
						<mat-form-field appearance="outline" class="input-full-width">
							<mat-label>Filter Templates</mat-label>
							<mat-select
								placeholder="Filter Templates"
								[(ngModel)]="filterType"
								id="filterTemplates"
								(ngModelChange)="selectedTemplate = null; applyFilter($event)"
								aria-label="Filter Templates {{ filterType ? 'list box with ' + filterType + ' value selected' : '' }}"
							>
								<mat-option *ngFor="let item of filterTypeOptions" [value]="item">
									{{ item }}
								</mat-option>
							</mat-select>
						</mat-form-field>
					</div>
					<div fxFlex="69.3" fxFlex.md="69.3" fxFlex.sm="100" fxFlex.xs="100" class="margin-bottom-10">
						<mat-form-field class="input-full-width" appearance="outline">
							<mat-label>Search Templates</mat-label>
							<input
								matInput
								id="filterDocuments"
								name="filter Documents"
								[(ngModel)]="selectedTemplate"
								(ngModelChange)="applyFilter()"
								[matAutocomplete]="auto"
							/>
							<mat-autocomplete
								#auto="matAutocomplete"
								(optionSelected)="onTemplateSelected($event)"
								[displayWith]="displayFn"
							>
								<mat-option *ngFor="let item of dropdownTemplatesData" [value]="item">
									{{ item.templateName }}
								</mat-option>
								<mat-option *ngIf="dropdownTemplatesData?.length === 0"> No Templates found </mat-option>
							</mat-autocomplete>
							<div role="status" class="sr-only" aria-live="polite">
								<span *ngIf="dropdownTemplatesData?.length > 0"
									>There are {{ dropdownTemplatesData?.length }} results available. Use the up and down arrows to
									navigate between options.</span
								>
								<span *ngIf="dropdownTemplatesData?.length === 0">0 results available</span>
							</div>
						</mat-form-field>
					</div>
				</div>
				<ng-container *ngIf="selectedTemplate?.templateCode === 'SUBWGTRVW' || selectedTemplate?.templateCode === 'SUBWGTRVWDFT'">
					<div *ngIf="selectedTemplate && selectedTemplate?.adHocFields">
						<label class="inner-text"><b>Enter Additional Information</b></label>
						<div fxLayout="row wrap" fxLayoutAlign="space-between stretch" class="margin-top-10">
							<div
							    fxFlex="49.3"
								*ngFor="let item of adHocFieldsList; let ind = index"
								fxFlex.md="49.3"
								fxFlex.sm="100"
								fxFlex.xs="100">
							
								<ng-container *ngIf="item.type == 'select' && item.field !== 'sltpCoordinatorName'">
									<mat-form-field class="input-full-width" appearance="outline">
										<mat-label>Select {{ item.display }}</mat-label>
										<mat-select
											placeholder="Reason"
											[(ngModel)]="adHocFields[item.field]"
											(ngModelChange)="
												onSelectChange(item.field, adHocFields[item.field], ind); checkReason($event, item.field)
											"
											id="adhoc_{{ item.field }}"
											required
											aria-label="{{ item.display }} {{
												adHocFields[item.field]
													? 'list box with ' +
													  getDescriptionByValue(adHocFields[item.field], getDropDownData(item)) +
													  ' value selected'
													: ''
											}}"
										>
											<mat-option *ngFor="let item of getDropDownData(item)" [value]="item.code">
												{{ item.description }}
											</mat-option>
										</mat-select>
									</mat-form-field>
								</ng-container>
								
								<ng-container *ngIf="item.type == 'multi'">
									<mat-form-field class="input-full-width" appearance="outline">
										<mat-label>{{ multiFieldDisplayLabel(item.display) }}</mat-label>
										<mat-select
											multiple
											[(ngModel)]="adHocFields[item.field]"
											(ngModelChange)="
												onSelectChange(item.field, adHocFields[item.field], ind); checkReason($event, item.field)
											"
											id="adhoc_{{ item.field }}"
											[required]="!noSelection" 
										    [disabled] = "noSelection"
											aria-label="{{ item.display }} {{
												adHocFields[item.field]
													? 'list box with ' +
													  getDescriptionByValue(adHocFields[item.field], getDropDownData(item)) +
													  ' value selected'
													: ''
											}}"
										>
											<mat-option *ngFor="let item of getDropDownData(item)" [value]="item.code">
												{{ item.description }}
											</mat-option>
										</mat-select>
									</mat-form-field>
								</ng-container>
								<ng-container *ngIf="item.type == 'radio'">
									<mat-label>{{ item.display }}</mat-label>
									<mat-radio-group
										class="template-radio-group"
										(ngModelChange)="onRadioChange(adHocFields[item.field], $event)"
										[(ngModel)]="adHocFields[item.field]"
									>
										<mat-radio-button class="template-radio-button" [value]="true" id="ad-hoc-yes-radio-btn-{{ ind }}">
											Yes
										</mat-radio-button>
										<mat-radio-button class="template-radio-button" [value]="false" id="ad-hoc-no-radion-btn-{{ ind }}">
											No
										</mat-radio-button>
									</mat-radio-group>
								</ng-container>
							</div>
						</div>
						
						<div *ngIf = "showIntakeReviewSection" fxLayout="row wrap" fxLayoutAlign="space-between stretch" class="margin-bottom-10 margin-top-0">
							<div
								fxFlex="100"
								*ngFor="let item of adHocFieldsList | slice:2:10; let ind = index"
								fxFlex.md="100"
								fxFlex.sm="100"
								fxFlex.xs="100"> 
								<div *ngIf="showIntakeReviewSection && item.type === 'intakeReview'">
										<mat-form-field class="input-full-width" appearance="outline">
										<mat-label>{{ intakeReviewDisplayLabel(item.display) }}</mat-label>
										<mat-select
											placeholder="Answer"
											[(ngModel)]="adHocFieldsList[item.field]"
											(ngModelChange)="
												onSelectChange(item.field, adHocFieldsList[item.field], ind); checkReason($event, item.field)
											"
											id="adhoc_{{ item.field }}"
											[required] = showIntakeReviewSection 
											aria-label="{{ item.display }} {{
												adHocFieldsList[item.field]
													? 'list box with ' +
														getDescriptionByValue(adHocFieldsList[item.field], getDropDownData(item)) +
														' value selected'
													: ''
											}}"	>
											<mat-option *ngFor="let item of intakeReviewSwrOptions" [value]="item.code">
												{{ item.description }}
											</mat-option>
										</mat-select>
									</mat-form-field>
									
								</div>
								</div>
						</div>
						<div fxLayout="row wrap" fxLayoutAlign="space-between stretch" class="margin-top-0">				
							<div 
							[fxFlex]="item.type == 'area' ? 100 : 49.3"
								*ngFor="let item of adHocFieldsList | slice:15; let ind = index"
								[fxFlex.md]="item.type == 'area' ? 100 : 49.3" 
								fxFlex.sm="100"
								fxFlex.xs="100" >
                                
								<ng-container *ngIf="item.field === 'sltpCoordinatorName'">
									<mat-form-field class="input-full-width" appearance="outline">
										<mat-label>Select {{ item.display }}</mat-label>
										<mat-select
											placeholder="Reason"
											[(ngModel)]="adHocFields[item.field]"
											(ngModelChange)="
												onSelectChange(item.field, adHocFields[item.field], ind); checkReason($event, item.field)
											"
											id="adhoc_{{ item.field }}"
											required
											aria-label="{{ item.display }} {{
												adHocFields[item.field]
													? 'list box with ' +
													  getDescriptionByValue(adHocFields[item.field], getDropDownData(item)) +
													  ' value selected'
													: ''
											}}"
										>
											<mat-option *ngFor="let item of getDropDownData(item)" [value]="item.code">
												{{ item.description }}
											</mat-option>
										</mat-select>
									</mat-form-field>
								</ng-container>

								<ng-container *ngIf="item.type == 'other'">
									<mat-form-field class="input-full-width" appearance="outline">
										<mat-label>{{ item.display }}</mat-label>
										<input
											matInput
											id="adhoc_{{ ind }}"
											name="adhoc_{{ ind }}"
											[maxlength]="item.maxLength"
											[(ngModel)]="adHocFields[item.field]"
											[matTooltip]="item.display"
											[appAnnounceTooltip]="item.display"
											required
										/>
									<mat-hint align="end" *ngIf="item.maxLength">
										{{ adHocFields[item.field]?.length || 0 }} /{{ item.maxLength }}
									</mat-hint>
								</mat-form-field>
							</ng-container>
					
					<ng-container *ngIf="item.type == 'area'">
						<mat-form-field class="input-full-width" appearance="outline">
							<mat-label>{{ item.display }}</mat-label>
							<textarea 
								matInput
								cdkTextareaAutosize
								[maxLength]="item.maxLength"
								cdkAutosizeMinRows="2"
								cdkAutosizeMaxRows="2"
								spellcheck="true"
								[(ngModel)]="adHocFields[item.field]"
								id="item.field"
								required
							></textarea>
							<mat-hint align="end" *ngIf="item.maxLength">
								{{ adHocFields[item.field]?.length || 0 }} /{{ item.maxLength }}
							</mat-hint>
						</mat-form-field>
					</ng-container>
					</div>
				</div>
			</div>
		</ng-container>
		<ng-container *ngIf="selectedTemplate?.officeCode !== null && selectedTemplate?.templateCode !== 'SUBWGTRVW' && selectedTemplate?.templateCode !== 'SUBWGTRVWDFT'">
			<div *ngIf="selectedTemplate && selectedTemplate?.adHocFields">

				<label class="inner-text"><b>Enter Additional Information</b></label>
				<div fxLayout="row wrap" fxLayoutAlign="space-between stretch" class="margin-bottom-10">
					<div
						[fxFlex]="item.type == 'area' ? 100 : 49.3"
						*ngFor="let item of adHocFieldsList; let ind = index"
						[fxFlex.md]="item.type == 'area' ? 100 : 49.3"
						fxFlex.sm="100"
						fxFlex.xs="100"
						class="margin-bottom-10"
					>
					<ng-container *ngIf="item.type == 'select'" >
									<mat-form-field class="input-full-width" appearance="outline">
										<mat-label>Select {{ item.display }}</mat-label>
										<mat-select
											placeholder="Reason"
											[(ngModel)]="adHocFields[item.field]"
											(ngModelChange)="
												onSelectChange(item.field, adHocFields[item.field], ind); checkReason($event, item.field)
											"
											id="adhoc_{{ item.field }}"
											required
											aria-label="{{ item.display }} {{
												adHocFields[item.field]
													? 'list box with ' +
													  getDescriptionByValue(adHocFields[item.field], getDropDownData(item)) +
													  ' value selected'
													: ''
											}}"
										>
											<mat-option *ngFor="let item of getDropDownData(item)" [value]="item.code">
												{{ item.description }}
											</mat-option>
										</mat-select>
									</mat-form-field>
								</ng-container>
								<ng-container *ngIf="item.type == 'multi'">
									<mat-form-field class="input-full-width" appearance="outline">
										<mat-label>{{ multiFieldDisplayLabel(item.display) }}</mat-label>
										<mat-select
											multiple
											[(ngModel)]="adHocFields[item.field]"
											(ngModelChange)="
												onSelectChange(item.field, adHocFields[item.field], ind); checkReason($event, item.field)
											"
											id="adhoc_{{ item.field }}"
											[required]="!noSelection" 
										    [disabled] = "noSelection"
											aria-label="{{ item.display }} {{
												adHocFields[item.field]
													? 'list box with ' +
													  getDescriptionByValue(adHocFields[item.field], getDropDownData(item)) +
													  ' value selected'
													: ''
											}}"
										>
											<mat-option *ngFor="let item of getDropDownData(item)" [value]="item.code">
												{{ item.description }}
											</mat-option>
										</mat-select>
									</mat-form-field>
								</ng-container>

								<ng-container *ngIf="item.type == 'radio'">
									<mat-label>{{ item.display }}</mat-label>
									<mat-radio-group
										class="template-radio-group"
										(ngModelChange)="onRadioChange(adHocFields[item.field], $event)"
										[(ngModel)]="adHocFields[item.field]"
									>
										<mat-radio-button class="template-radio-button" [value]="true" id="ad-hoc-yes-radio-btn-{{ ind }}">
											Yes
										</mat-radio-button>
										<mat-radio-button class="template-radio-button" [value]="false" id="ad-hoc-no-radion-btn-{{ ind }}">
											No
										</mat-radio-button>
									</mat-radio-group>
								</ng-container>
								
								<ng-container *ngIf="item.type == 'other'">
									<mat-form-field class="input-full-width" appearance="outline">
										<mat-label>{{ item.display }}</mat-label>
										<input
											matInput
										id="adhoc_{{ ind }}"
										name="adhoc_{{ ind }}"
										[maxlength]="item.maxLength"
										[(ngModel)]="adHocFields[item.field]"
										[matTooltip]="item.display"
										[appAnnounceTooltip]="item.display"
										required
									/>
									<mat-hint align="end" *ngIf="item.maxLength">
										{{ adHocFields[item.field]?.length || 0 }} /{{ item.maxLength }}
									</mat-hint>
								</mat-form-field>
								</ng-container>							
							<ng-container *ngIf="item.type == 'area'">
								<mat-form-field class="input-full-width" appearance="outline">
									<mat-label>{{ item.display }}</mat-label>
									<textarea 
										matInput
										cdkTextareaAutosize
										[maxLength]="item.maxLength"
										cdkAutosizeMinRows="3"
										cdkAutosizeMaxRows="3"
										spellcheck="true"
										[(ngModel)]="adHocFields[item.field]"
										id="adhoc_{{ item.field }}"
										required
									></textarea>
									<mat-hint align="end" *ngIf="item.maxLength">
										{{ adHocFields[item.field]?.length || 0 }} /{{ item.maxLength }}
									</mat-hint>
								</mat-form-field>
							</ng-container>							</div>
						</div>
					</div>			
				</ng-container>
				<ng-container *ngIf="selectedTemplate?.officeCode !== null && selectedTemplate?.templateCode !== 'SUBWGTRVW' && selectedTemplate?.templateCode !== 'SUBWGTRVWDFT'">
					<div *ngIf="selectedTemplate && selectedTemplate?.adHocFields">

						<label class="inner-text"><b>Enter Additional Information</b></label>
						<div fxLayout="row wrap" fxLayoutAlign="space-between stretch" class="margin-bottom-10">
							<div
							[fxFlex]="item.type == 'area' ? 100 : 49.3"
							*ngFor="let item of adHocFieldsList; let ind = index"
							[fxFlex.md]="item.type == 'area' ? 100 : 49.3"
								fxFlex.sm="100"
								fxFlex.xs="100"
								class="margin-bottom-10"
							>
								<ng-container *ngIf="item.type == 'datetime'">
									<date-time-picker
										[label]="item.display"
										[minDate]="minDate"
										(dateChange)="adHocFields[item.field] = $event"
									></date-time-picker>
								</ng-container>
								<ng-container *ngIf="item.type == 'date'">
									<mat-form-field class="input-full-width" appearance="outline">
										<mat-label>{{ item.display }}</mat-label>
										<input
											matInput
											[matDatepicker]="dynamicPicker"
											[min]="minDate"
											[(ngModel)]="adHocFields[item.field]"
											id="dynamicPicker{{ ind }}"
										/>
										<mat-datepicker-toggle
											matSuffix
											[for]="dynamicPicker"
											id="dynamic-date-picker-{{ ind }}"
										></mat-datepicker-toggle>
										<mat-datepicker #dynamicPicker></mat-datepicker>
									</mat-form-field>
								</ng-container>
								<ng-container *ngIf="item.type == 'other'">
									<mat-form-field class="input-full-width" appearance="outline">
										<mat-label>{{ item.display }}</mat-label>
										<input
											matInput
											id="adhoc_{{ ind }}"
											name="adhoc_{{ ind }}"
											[(ngModel)]="adHocFields[item.field]"
											required
										/>
									</mat-form-field>
								</ng-container>
								
								<ng-container *ngIf="item.type == 'area'">
									<mat-form-field class="input-full-width" appearance="outline">
										<mat-label>{{ item.display }}</mat-label>
										<textarea 
											matInput
											cdkTextareaAutosize
											[maxLength]="item.maxLength"
											cdkAutosizeMinRows="2"
											cdkAutosizeMaxRows="2"
											spellcheck="true"
											[(ngModel)]="adHocFields[item.field]"
											id="adhoc_{{ item.field }}"
											required
										></textarea>
										<mat-hint align="end" *ngIf="item.maxLength">
											{{ adHocFields[item.field]?.length || 0 }} /{{ item.maxLength }}
										</mat-hint>
									</mat-form-field>
								</ng-container>
								
								<ng-container *ngIf="item.type == 'radio'">
									<mat-label>{{ item.display }}</mat-label>
									<mat-radio-group
										class="template-radio-group"
										(ngModelChange)="onRadioChange('citation', $event)"
										[(ngModel)]="adHocFields['citation']"
									>
										<mat-radio-button class="template-radio-button" [value]="true" id="ad-hoc-yes-radio-btn-{{ ind }}">
											Yes
										</mat-radio-button>
										<mat-radio-button class="template-radio-button" [value]="false" id="ad-hoc-no-radion-btn-{{ ind }}">
											No
										</mat-radio-button>
									</mat-radio-group>
								</ng-container>
							</div>
						</div>
					</div>
				</ng-container>
				<ng-container *ngIf="selectedTemplate && selectedTemplate?.officeCode === null && selectedTemplate?.templateCode !== 'SUBWGTRVW' && selectedTemplate?.templateCode !== 'SUBWGTRVWDFT'">
					<div *ngIf="adHocFieldsList.length > 0 && selectedTemplate?.templateCode !== 'RFIRES'">
						<label class="inner-text"><b>Enter Additional Information</b></label>
					</div>
					<ng-container *ngIf="stdTemplates.includes(selectedTemplate?.templateCode)">
						<div *ngIf="selectedTemplate?.templateCode == 'CODCL' || selectedTemplate?.templateCode == 'CODUCL'">
							<div fxLayout="row wrap" fxLayoutAlign="space-between stretch" class="margin-bottom-10">
								<div fxFlex="49.3" fxFlex.md="49.3" fxFlex.sm="100" fxFlex.xs="100" class="margin-bottom-10">
									<label class="inner-text">A notary signature is required</label>
									<mat-radio-group class="template-radio-group" [(ngModel)]="adHocFields['notaryReq']">
										<mat-radio-button class="template-radio-button" [value]="true" id="notary-yes-radio-btn">
											Yes
										</mat-radio-button>
										<mat-radio-button class="template-radio-button" [value]="false" id="notary-no-radio-btn">
											No
										</mat-radio-button>
									</mat-radio-group>
								</div>
							</div>
						</div>

						<div *ngIf="selectedTemplate?.templateCode === 'TRANSCASEDOJ'">
							<div fxLayout="row wrap" fxLayoutAlign="space-between stretch" class="margin-bottom-10">
								<div fxFlex="49.3" fxFlex.md="49.3" fxFlex.sm="100" fxFlex.xs="100">
									<label class="inner-text">Is referred for a determination to sue pursuant to:</label>
									<mat-radio-group class="template-radio-group" [(ngModel)]="adHocFields['citation']">
										<mat-radio-button
											class="template-radio-button"
											[value]="'Section 706(f)(1)'"
											id="section-706-f1-radio"
										>
											Section 706(f)(1)
										</mat-radio-button>
										<mat-radio-button
											class="template-radio-button"
											[value]="'Section 706(f)(2)'"
											id="section-706-f2-radio"
										>
											Section 706(f)(2)
										</mat-radio-button>
									</mat-radio-group>
								</div>
							</div>
							<div class="note-textarea margin-bottom-10">
								<label class="inner-text">Director or Legal Remarks</label>
								<mat-form-field class="input-full-width" appearance="outline">
									<mat-label>Enter Remarks</mat-label>
									<textarea
										matInput
										cdkTextareaAutosize
										[maxLength]="1000"
										cdkAutosizeMinRows="3"
										cdkAutosizeMaxRows="3"
										spellcheck="true"
										placeholder="Enter Remarks..."
										[(ngModel)]="adHocFields['remarks']"
										id="remarks"
										required
									></textarea>
								</mat-form-field>
								<div class="text-right inner-text">{{ adHocFields['remarks']?.length || 0 }} / 1000</div>
							</div>
						</div>
						<div *ngIf="selectedTemplate?.templateCode === 'TRANSCASEDOJFORNRTS'">
							<div fxLayout="row wrap" fxLayoutAlign="space-between stretch" class="margin-bottom-10">
								<div fxFlex="49.5" fxFlex.md="49.5" fxFlex.sm="100" fxFlex.xs="100" class="margin-bottom-10">
									<mat-form-field appearance="outline" class="input-full-width">
										<mat-label>Attachments</mat-label>
										<mat-select
											placeholder="Filter Templates"
											[(ngModel)]="adHocFields['attachments']"
											id="attachments"
											multiple
											aria-label="Attachments {{
												adHocFields['attachments']
													? 'list box with ' + adHocFields['attachments'] + ' value selected'
													: ''
											}}"
										>
											<mat-option *ngFor="let item of attachementOptions" [value]="item.description">
												{{ item.description }}
											</mat-option>
										</mat-select>
									</mat-form-field>
								</div>
								<div fxFlex="49.5" fxFlex.md="49.5" fxFlex.sm="100" fxFlex.xs="100" class="margin-bottom-10">
									<mat-form-field class="input-full-width" appearance="outline">
										<mat-label>Issued On</mat-label>
										<input
											matInput
											[matDatepicker]="picker4"
											placeholder="Issued On"
											[min]="minDate"
											[(ngModel)]="adHocFields['issuedOn']"
											[max]="maxDate"
											id="issued-on"
										/>
										<mat-datepicker-toggle matSuffix [for]="picker4" id="issued-on-date-picker"></mat-datepicker-toggle>
										<mat-datepicker #picker4></mat-datepicker>
									</mat-form-field>
								</div>
								<div fxFlex="49.5" fxFlex.md="49.5" fxFlex.sm="100" fxFlex.xs="100" class="margin-bottom-10">
									<mat-form-field appearance="outline" class="input-full-width">
										<mat-label>NRTS Requested By</mat-label>
										<mat-select
											placeholder="Filter Templates"
											[(ngModel)]="adHocFields['nrtsRequestedBy']"
											id="nrts-requested-by"
											aria-label="Filter Templates {{
												adHocFields['nrtsRequestedBy']
													? 'list box with ' + adHocFields['nrtsRequestedBy'] + ' value selected'
													: ''
											}}"
										>
											<mat-option *ngFor="let item of requestedByOptions" [value]="item.description">
												{{ item.description }}
											</mat-option>
										</mat-select>
									</mat-form-field>
								</div>
								<div fxFlex="49.5" fxFlex.md="49.5" fxFlex.sm="100" fxFlex.xs="100" class="margin-bottom-10">
									<mat-form-field class="input-full-width" appearance="outline">
										<mat-label>NRTS Request Date</mat-label>
										<input
											matInput
											[matDatepicker]="picker5"
											placeholder="NRTS Request Date"
											[min]="minDate"
											[(ngModel)]="adHocFields['nrtsRequestDate']"
											[max]="maxDate"
											id="nrts-requested-date"
										/>
										<mat-datepicker-toggle
											matSuffix
											[for]="picker5"
											id="nrts-request-date-date-picker"
										></mat-datepicker-toggle>
										<mat-datepicker #picker5></mat-datepicker>
									</mat-form-field>
								</div>
								<div fxFlex="49.5" fxFlex.md="49.5" fxFlex.sm="100" fxFlex.xs="100" class="margin-bottom-10">
									<label class="inner-text">EEOC to Continue Investigating?</label>
									<mat-radio-group class="template-radio-group" [(ngModel)]="adHocFields['eeocToContinue']">
										<mat-radio-button class="template-radio-button" [value]="'Yes'" id="invest-yes-radio-btn">
											Yes
										</mat-radio-button>
										<mat-radio-button class="template-radio-button" [value]="'No'" id="invest-no-radio-btn">
											No
										</mat-radio-button>
									</mat-radio-group>
								</div>
								<div fxFlex="49.5" fxFlex.md="49.5" fxFlex.sm="100" fxFlex.xs="100" class="margin-bottom-10">
									<label class="inner-text">Name of Contact Person:</label>
									<mat-form-field appearance="outline" class="input-full-width">
										<mat-label>Select Assigned Staff</mat-label>
										<mat-select
											placeholder="Select Assigned Staff"
											[disabled]="assignedStaffArray.length == 1"
											(ngModelChange)="onContactChange($event)"
											[(ngModel)]="adHocFields['eeocContactName']"
											id="assigned-staff"
											aria-label="Assigned Staff {{
												adHocFields['eeocContactName']
													? 'list box with ' + adHocFields['eeocContactName'] + ' value selected'
													: ''
											}}"
										>
											<mat-option *ngFor="let item of assignedStaffArray" [value]="item.name">
												{{ item.name }}
											</mat-option>
											<mat-option *ngIf="assignedStaffArray?.length === 0" [value]="null">
												Please assign staff to case
											</mat-option>
										</mat-select>
									</mat-form-field>
								</div>
							</div>
						</div>
					</ng-container>
					<ng-container *ngIf="!stdTemplates.includes(selectedTemplate?.templateCode) && selectedTemplate?.adHocFields  && selectedTemplate?.templateCode !== 'SUBWGTRVW' && selectedTemplate?.templateCode !== 'SUBWGTRVWDFT'">
						<div fxLayout="row wrap" fxLayoutAlign="space-between stretch" class="margin-bottom-10">
							<ng-container *ngFor="let item of adHocFieldsList; let ind = index">
								<div
								[fxFlex]="item.type == 'area' ? 100 : 49.3"
								*ngIf="item.isVisible"
								[fxFlex.md]="item.type == 'area' ? 100 : 49.3"
									fxFlex.sm="100"
									fxFlex.xs="100"
									class="margin-bottom-10"
								>
									<ng-container *ngIf="item.type == 'datetime'">
										<date-time-picker
											[label]="item.display"
											[minDate]="minDate"
											(dateChange)="adHocFields[item.field] = $event"
										></date-time-picker>
									</ng-container>
									<ng-container *ngIf="item.type == 'date'">
										<mat-form-field class="input-full-width" appearance="outline">
											<mat-label>{{ datePickerDisplayLabel(item.display) }}</mat-label>
											<input
												matInput
												[matDatepicker]="dynamicPicker"
												[min]="minDate"
												[(ngModel)]="adHocFields[item.field]"
												id="dynamicPicker{{ ind }}"
												required
											/>
											<mat-datepicker-toggle
												matSuffix
												[for]="dynamicPicker"
												id="template-dynamic-date-picker-{{ ind }}"
											></mat-datepicker-toggle>
											<mat-datepicker #dynamicPicker></mat-datepicker>
										</mat-form-field>
									</ng-container>
									<ng-container *ngIf="item.type == 'select'">
										<mat-form-field class="input-full-width" appearance="outline">
											<mat-label>Select {{ item.display }}</mat-label>
											<mat-select
												placeholder="Reason"
												[(ngModel)]="adHocFields[item.field]"
												(ngModelChange)="
													onSelectChange(item.field, adHocFields[item.field], ind); checkReason($event, item.field)
												"
												id="adhoc_{{ item.field }}"
												required
												aria-label="{{ item.display }} {{
													adHocFields[item.field]
														? 'list box with ' +
														  getDescriptionByValue(adHocFields[item.field], getDropDownData(item)) +
														  ' value selected'
														: ''
												}}"
											>
												<mat-option *ngFor="let item of getDropDownData(item)" [value]="item.code">
													{{ item.description }}
												</mat-option>
											</mat-select>
										</mat-form-field>
									</ng-container>
									
									<ng-container *ngIf="item.type == 'multi'">
										<mat-form-field class="input-full-width" appearance="outline">
											<mat-label>{{ multiFieldDisplayLabel(item.display) }}</mat-label>
											<mat-select
												multiple
												[(ngModel)]="adHocFields[item.field]"
												(ngModelChange)="
													onSelectChange(item.field, adHocFields[item.field], ind); checkReason($event, item.field)
												"
												id="adhoc_{{ item.field }}"
												required
												aria-label="{{ item.display }} {{
													adHocFields[item.field]
														? 'list box with ' +
														  getDescriptionByValue(adHocFields[item.field], getDropDownData(item)) +
														  ' value selected'
														: ''
												}}"
											>
												<mat-option *ngFor="let item of getDropDownData(item)" [value]="item.code">
													{{ item.description }}
												</mat-option>
											</mat-select>
										</mat-form-field>
									</ng-container>

									<ng-container *ngIf="item.type == 'other'">
										<mat-form-field class="input-full-width" appearance="outline">
											<mat-label>{{ item.display }}</mat-label>
											<input
												matInput
												id="adhoc_{{ ind }}"
												name="adhoc_{{ ind }}"
												[maxlength]="item.maxLength"
												[(ngModel)]="adHocFields[item.field]"
												[matTooltip]="item.display"
												[appAnnounceTooltip]="item.display"
												required
											/>
										<mat-hint align="end" *ngIf="item.maxLength">
											{{ adHocFields[item.field]?.length || 0 }} /{{ item.maxLength }}
										</mat-hint>
									</mat-form-field>
									</ng-container>
									
									<ng-container *ngIf="item.type == 'area'">
										<mat-form-field class="input-full-width" appearance="outline">
											<mat-label>{{ item.display }}</mat-label>
											<textarea 
												matInput
												cdkTextareaAutosize
												[maxLength]="item.maxLength"
												cdkAutosizeMinRows="3"
												cdkAutosizeMaxRows="3"
												spellcheck="true"
												[(ngModel)]="adHocFields[item.field]"
												id="adhoc_{{ item.field }}"
												required
											></textarea>
											<mat-hint align="end" *ngIf="item.maxLength">
												{{ adHocFields[item.field]?.length || 0 }} /{{ item.maxLength }}
											</mat-hint>
										</mat-form-field>
									</ng-container>
									
									<ng-container *ngIf="item.type == 'radio' && item.isVisible">
										<mat-label>{{ radioGroupDisplayLabel(item.display) }}</mat-label>
										<mat-radio-group
											class="template-radio-group"
											id="adhoc_radio_{{ ind }}"
											name="adhoc_radio_{{ ind }}"
											[(ngModel)]="adHocFields[item.field]"
											(ngModelChange)="onRadioChange(item.field, $event)"
										>
											<mat-radio-button
												class="template-radio-button"
												[value]="true"
												id="ad-hoc-template-radio-yes-{{ ind }}"
											>
												Yes
											</mat-radio-button>
											<mat-radio-button
												class="template-radio-button"
												[value]="false"
												id="ad-hoc-template-radio-no-{{ ind }}"
											>
												No
											</mat-radio-button>
											<!-- <mat-radio-button
											class="template-radio-button"
											[value]="'null'"
											*ngIf="item.field === 'adoptFEPAClosure' || item.field === 'eeocContinueInvestigation'"
										>
											Not applicable
										</mat-radio-button> -->
										</mat-radio-group>
									</ng-container>
								</div>
							</ng-container>
							<div
								fxFlex="49.3"
								*ngIf="hasClosureReason && adHocFields.closureReason == 'OTH_1'"
								fxFlex.md="49.3"
								fxFlex.sm="100"
								fxFlex.xs="100"
								class="margin-bottom-10"
							>
								<mat-form-field class="input-full-width" appearance="outline">
									<mat-label>Other Closure Reason</mat-label>
									<textarea
										matInput
										cdkTextareaAutosize
										[maxLength]="140"
										id="charge-close"
										cdkAutosizeMinRows="3"
										cdkAutosizeMaxRows="3"
										spellcheck="true"
										#otherClosureReason="ngModel"
										[(ngModel)]="adHocFields.otherClosureReason"
										id="other-closure-reason"
										placeholder="Enter Other Closure Reason..."
										required
									></textarea>
									<mat-error *ngIf="otherClosureReason.invalid && otherClosureReason.touched">
										You must enter a other closure reason
									</mat-error>
								</mat-form-field>
								<div class="text-right text-area-count">{{ adHocFields.otherClosureReason?.length || 0 }} / 140</div>
							</div>
						</div>
					</ng-container>
				</ng-container>
			</div>
			<!-- <div class="inner-text">
				<label><b>Confirm Form Generation</b></label>

				<div class="blue-gb margin-top-15">
					<mat-checkbox [(ngModel)]="accept" class="checkbox-min-width margin-checkbox text-center mr-2">
					</mat-checkbox>
					<span
						>I confirm that I would like to generate the following template:
						<b>{{ selectedTemplate?.templateName }}</b></span
					>
				</div>
			</div> -->
		</div>
	</mat-dialog-content>
	<mat-divider></mat-divider>
	<mat-dialog-actions class="mb-0 justify-content-between">
		<div class="margin-left-20">
			<button mat-button color="primary" class="text-left" matDialogClose id="cancel-doc-template-btn">CANCEL</button>
		</div>

		<div class="d-flex v-center" *ngIf="(selectedTemplate?.templateCode === 'SUBWGTRVWDFT' || selectedTemplate?.templateCode === 'SUBWGTRVW')  && selectedTemplate?.officeCode == null">
			<mat-icon
				[inline]="true"
				color="primary"
				matTooltip="Word draft will be auto-generated and downloaded as the draft document to this case file"
				appAnnounceTooltip="Word draft will be auto-generated and downloaded as the draft document to this case file"
				tabindex="0"
				aria-label="Generate as Draft in Word"
				role="none"
			>
				info
			</mat-icon>
			<button
				class="float-right ml-2"
				[disabled]="isDisabled()"
				mat-flat-button
				color="primary"
				appDebounceClick
				(debounceClick)="openTemplate('docx')"
				id="generate-as-draft-word-btn"
			>
			Generate as draft in Word
			</button>
		</div>

		<div class="d-flex v-center" *ngIf="(selectedTemplate?.templateCode === 'SUBWGTRVWDFT' || selectedTemplate?.templateCode === 'SUBWGTRVW')  && selectedTemplate?.officeCode == null">
			<mat-icon
				[inline]="true"
				color="primary"
				matTooltip="PDFs will be auto-generated and auto-uploaded as the finalized document to this case file"
				appAnnounceTooltip="PDFs will be auto-generated and auto-uploaded as the finalized document to this case file"
				tabindex="0"
				aria-label="Generate as Final Version in PDF"
				role="none"
			>
				info
			</mat-icon>
			<button
				class="float-right ml-2"
				[disabled]="isDisabled()"
				mat-flat-button
				color="primary"
				appDebounceClick
				(debounceClick)="openTemplate('pdf')"
				id="generate-final-pdf-template-btn"
			>
			Generate as Final Version in PDF
			</button>
		</div>

		<div class="margin-right-20 d-flex">
			<div class="mr-2 d-flex v-center" *ngIf="(selectedTemplate?.templateCode !== 'SUBWGTRVWDFT' && selectedTemplate?.templateCode !== 'SUBWGTRVW')  && selectedTemplate?.templateExtension !== 'pdf'">
				<mat-icon
					[inline]="true"
					color="primary"
					matTooltip="Generate and open the document in Word. You'll need to save and upload the finalized document to this case file"
					appAnnounceTooltip="Generate and open the document in Word. You'll need to save and upload the finalized document to this case file"
					tabindex="0"
					aria-label="Generate Microsoft Word Template"
					role="none"
				>
					info
				</mat-icon>
				<button
					class="float-right ml-2"
					mat-flat-button
					color="primary"
					[disabled]="isDisabled()"
					appDebounceClick
					(debounceClick)="openTemplate('docx')"
					id="generate-word-template-btn"
				>
					GENERATE WORD TEMPLATE
				</button>
			</div>
			<div class="d-flex v-center" *ngIf="(selectedTemplate?.templateCode !== 'SUBWGTRVWDFT' && selectedTemplate?.templateCode !== 'SUBWGTRVW')  && selectedTemplate?.officeCode == null">
				<mat-icon
					[inline]="true"
					color="primary"
					matTooltip="PDFs will be auto-generated and auto-uploaded as the finalized document to this case file"
					appAnnounceTooltip="PDFs will be auto-generated and auto-uploaded as the finalized document to this case file"
					tabindex="0"
					aria-label="Generate PDF"
					role="none"
				>
					info
				</mat-icon>
				<button
					class="float-right ml-2"
					[disabled]="isDisabled()"
					mat-flat-button
					color="primary"
					appDebounceClick
					(debounceClick)="openTemplate('pdf')"
					id="generate-pdf-template-btn"
				>
					GENERATE PDF
				</button>
			</div>
		</div>
	</mat-dialog-actions>
</ng-template>